import React, { ReactElement } from 'react';
import { HeadTag } from 'shared/components';
import { Box, SvgIcon } from '@mui/material';
import { FieldArray, Formik } from 'formik';
import { AppFormikButtonTiles } from 'shared/components/AppComponents';
// import ActiveConnectionsCard from './components/ActiveConnectionsCard';
// import { ReactComponent as Connection } from 'assets/images/ic_connection.svg';
import { ReactComponent as GitHub } from 'assets/images/ic_github.svg';
import { ReactComponent as HuggingFace } from 'assets/images/ic_hugging_face.svg';
import { ReactComponent as VertexAI } from 'assets/images/ic_vertexAI.svg';
import { ReactComponent as CopilotStudio } from 'assets/images/ic_copilot_studio.svg';
import { ReactComponent as Okta } from 'assets/images/ic_okta.svg';
import { ReactComponent as Defender } from 'assets/images/ic_defender.svg';
import ShadowAIDiscovery from './components/ShadowAIDiscoveryCard';
import ActiveGithubCard from './components/ActiveGithubCard';
import ActiveHuggingFaceCard from './components/ActiveHuggingFaceCard';
// import ActiveVertexCard from './components/ActiveVertexCard';
// import ActiveCopilotCard from './components/ActiveCopilotCard';
// import ActiveOktaCard from './components/ActiveOktaCard';
// import ActiveDefenderCard from './components/ActiveDefenderCard';
// import RequestConnectorCard from './components/RequestConnectionsCard';
import PageHeader from 'shared/components/PageHeader';
import ComingSoonCard from 'shared/components/ComingSoonCard';

const DiscoveryAI = (): ReactElement => {
  const Buttons = [
    // {
    //   value: 'Connections',
    //   startIcon: (
    //     <SvgIcon
    //       component={Connection}
    //       inheritViewBox
    //       className="view-icon"
    //       fontSize="inherit"
    //       htmlColor="#76A81F"
    //     />
    //   ),
    // },
    {
      value: 'GitHub',
      startIcon: (
        <SvgIcon
          component={GitHub}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Hugging Face',
      startIcon: (
        <SvgIcon
          component={HuggingFace}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Vertex AI',
      startIcon: (
        <SvgIcon
          component={VertexAI}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Copilot Studio',
      startIcon: (
        <SvgIcon
          component={CopilotStudio}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Okta',
      startIcon: (
        <SvgIcon
          component={Okta}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Defender',
      startIcon: (
        <SvgIcon
          component={Defender}
          inheritViewBox
          className="view-icon"
          fontSize="inherit"
          htmlColor="#76A81F"
        />
      ),
    },
    {
      value: 'Request Connector',
    },
  ];
  const title = (status: boolean[]): string => {
    const index = status.findIndex((s) => s);
    if (index > -1) {
      return Buttons[index].value;
    }
    return '';
  };
  // UI Element
  return (
    <>
      <PageHeader
        title="Discover Shadow AI Systems"
        description="Connect and browse embedded AI systems within your enterprise tools"
      />

      <Box className="ai-inventory discovery mt-5">
        <HeadTag title="Discovery AI" />
        <Formik
          enableReinitialize
          initialValues={{
            status: [true, false, false, false, false, false],
          }}
          validateOnMount
          onSubmit={() => console.log('test')}
        >
          {() => (
            <Box className="discovery-wrapper">
              <AppFormikButtonTiles
                variant="outlined"
                name="status"
                size="small"
                label=""
                disabled={false}
                multichoice={false}
                className="app-group-button"
                buttons={Buttons}
                outerLabel
              />

              {false && <ShadowAIDiscovery />}
              <FieldArray
                name="status"
                render={({ form }) => {
                  const { values } = form;
                  // if (
                  //   values.status.some((t: any, i: any) => i === 0 && t === true)
                  // ) {
                  //   return <ActiveConnectionsCard />;
                  // }
                  if (
                    values.status.some(
                      (t: any, i: any) => i === 0 && t === true
                    )
                  ) {
                    return <ActiveGithubCard />;
                  }
                  if (
                    values.status.some(
                      (t: any, i: any) => i === 1 && t === true
                    )
                  ) {
                    return <ActiveHuggingFaceCard />;
                  }
                  // if (
                  //   values.status.some((t: any, i: any) => i === 2 && t === true)
                  // ) {
                  //   return <ActiveVertexCard />;
                  // }
                  // if (
                  //   values.status.some((t: any, i: any) => i === 3 && t === true)
                  // ) {
                  //   return <ActiveCopilotCard />;
                  // }
                  // if (
                  //   values.status.some((t: any, i: any) => i === 4 && t === true)
                  // ) {
                  //   return <ActiveOktaCard />;
                  // }
                  // if (
                  //   values.status.some((t: any, i: any) => i === 5 && t === true)
                  // ) {
                  //   return <ActiveDefenderCard />;
                  // }
                  // if (
                  //   values.status.some((t: any, i: any) => i === 6 && t === true)
                  // ) {
                  //   return <RequestConnectorCard />;
                  // }
                  return <ComingSoonCard title={title(values.status)} />;
                }}
              />
            </Box>
          )}
        </Formik>
      </Box>
    </>
  );
};

export default DiscoveryAI;
